function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), React.createElement("path", {
  d: "M32 16a16 16 0 01-16 16 15.81 15.81 0 01-5.82-1.1A13.27 13.27 0 0022.58 8l3.53-4.4A16 16 0 0132 16zM7.54 5.5a13.27 13.27 0 0114.9-4.14A16 16 0 006 28.46l3.52-4.38A13.26 13.26 0 017.54 5.5z"
})));